import Typography from "../../reusable/Typography/Typography"
import React, {useContext} from "react"
import {useTranslation} from "next-i18next"
import Image from "next/image"
import OrganizationContext from "../../../context/OrganizationContext"
import useDiscount from "../../../hooks/useDiscount"
import {formatPrice} from "../../../utility/Helper"
import getMainCategory from "../../filter/GetMainCategory"
import {categorySlugs} from "../../filter/config/Categories"

type Props = {
	product: any
	isSecondHand: boolean
	disabled?: boolean
	isLoading?: boolean
	handleClick?: any
	isAccessory?: boolean
	handleSizeClick?: any
	planLength?: any
	initialPrice?: any
	customInstanceDiscount?: number
	isOnSale?: boolean
	hideTooltip?: boolean
    hasEditFinancingBtn?: boolean
    handleEditFinanceBtnClick?: (isModalOpen?: boolean) => void
}

const PriceTooltipWithCheckoutBtn: React.FC<Props> = ({
	handleEditFinanceBtnClick,
	hasEditFinancingBtn,
	hideTooltip = false,
	handleSizeClick,
	isSecondHand,
	initialPrice,
	handleClick,
	planLength,
	isLoading,
	disabled,
	isOnSale,
	product
}) => {
	const mainCategory = getMainCategory(product?.categories)

	const {organizationSlug, organizationData} = useContext(OrganizationContext)
	const isAccessory = mainCategory?.name.toLowerCase() === categorySlugs.accessories ||
	product?.categories?.some(cat => cat?.slug === "zubehoer")
	const {t} = useTranslation()
	const {finalPriceWithDownPayment, finalPriceWithoutDownPayment, discount, onSale} = useDiscount(product)
	const customInstanceDiscount = organizationData?.key === "qoqa" && product.uvpPrice > 3500 && !isAccessory ? Number(discount || 0) + 555 : organizationSlug && onSale && (!product.discount || product.discount !== discount) ? discount : false
	const displayDiscountPrice = organizationData?.key === "qoqa" && product.uvpPrice > 3500 && !isAccessory ? discount + 555 : discount
	const showPartnershipExclusiveText = onSale || organizationSlug && !product.discount || organizationData?.key === "qoqa" && product.uvpPrice > 3500 && !isAccessory
	const textVariant = hasEditFinancingBtn ? "bodyXSm" : "bodySm"

	return (
		<div className="d-flex align-items-center justify-content-between text-start mt-4 pt-1">
			<div className={`${hasEditFinancingBtn ? "col-auto" : "col-12"}`}>
				{/* Price Tooltip For Discount */}
				{showPartnershipExclusiveText && !hideTooltip && <div style={{backgroundColor: customInstanceDiscount && organizationData?.banner?.bgColor ? organizationData?.banner?.bgColor : "#EC0000"}}
					className="col-12 text-white downpayment-price-tooltip position-relative d-flex gap-2 align-items-center justify-content-between">
					<div className="d-flex align-items-center">
						{organizationSlug && showPartnershipExclusiveText && !(organizationData?.key === "qoqa" && product.uvpPrice < 3500 && !isAccessory) &&
							<>
								<div className="d-none d-md-flex align-items-center">
									<Image src={organizationSlug ? organizationData?.companyIcon : null}
										className="d-none d-md-block"
										height={24}
										width={40}/>
								</div>
								<div className="d-flex d-md-none align-items-center">
									<Image
										src={organizationSlug ? organizationData?.companyIcon : null}
										className="d-block d-md-none"
										height={12}
										width={20}/>
								</div>
							</>
						}
						<Typography variant="bodySmBold"
							className={`${organizationSlug ? "ms-2 " : ""} d-none d-md-block`}
							semanticTag="span"
							style={{lineHeight: "normal"}}>{(organizationSlug && customInstanceDiscount) ? organizationData?.companyName : null} {t("exclusive-discount")} </Typography>
						<Typography variant="bodyXSmBold"
							className={`${organizationSlug ? "ms-2 " : ""} d-md-none`}
							semanticTag="span"
							style={{lineHeight: "normal"}}>{(organizationSlug && customInstanceDiscount) ? organizationData?.companyName : null} {t("exclusive-discount")}</Typography>
					</div>
					<Typography variant="bodySmBold"
						semanticTag="span"
						className="ms-2 d-none d-md-block"
						style={{lineHeight: "normal"}}>-{displayDiscountPrice} CHF</Typography>
					<Typography variant="bodyXSmBold"
						semanticTag="span"
						className="ms-2 d-md-none"
						style={{lineHeight: "normal"}}>-{displayDiscountPrice} CHF</Typography>
					<div className="banner_bottom_arrow" />
					<style jsx>{`

.banner_bottom_arrow {
	clip-path: polygon(100% 0, 0 0, 50% 51%);
	position: absolute;
	bottom: .25;
	transform:translateY(100%);
	left: 2rem;
	background-color: ${organizationData?.banner?.bgColor && (organizationData?.key === "qoqa" && product.uvpPrice > 3500 && !isAccessory || organizationSlug && organizationSlug !== "qoqa") ? organizationData?.banner?.bgColor : "#EC0000"};
	width: 30px; 
	height: 32px;
  }

  @media and screen (max-width:780px){
	.banner_bottom_arrow {
		width: 25px; 
		height: 30px;
	  }
  }
`}</style>
				</div>}
				{/* Checkout Data & Button */}
				<div className="d-flex align-items-center justify-content-between"
					style={{marginTop: 12}}>
					<div className="col-auto position-relative">
						<div className="col-auto"
							style={{color: onSale || customInstanceDiscount ? "#E61C45" : ""}}>
							<Typography variant={"bodySmBold"}
								semanticTag="span">CHF</Typography>
							<Typography variant={"heading1Black"}
								className="ms-1"
								semanticTag="span"
								style={{fontSize: hasEditFinancingBtn ? 28 : 36, lineHeight: 1.3}}>
								{`${Math.ceil(organizationData?.key === "qoqa" && product.uvpPrice > 3500 && !isAccessory ? (finalPriceWithDownPayment - 555) / (planLength) : finalPriceWithDownPayment / (planLength))}`}
							</Typography>
							<Typography variant={"bodySmBold"}
								semanticTag="span"
								className="ms-1">
								{`${t("pro Monat")}`}
							</Typography>
							{!isSecondHand && (
								<div style={{color: "#6C7074"}}>
									<Typography variant={textVariant}
										semanticTag="span"
										className={"text-start col-12 text-capitalize"}
										style={{color: onSale || customInstanceDiscount ? "#E61C45" : ""}}>
										{`${t("Gesamtpreis")}: `}
									</Typography>
									<Typography variant={textVariant}
										semanticTag="span"
										style={{color: onSale || customInstanceDiscount ? "#E61C45" : ""}}>
										{organizationData?.key === "qoqa" && product.uvpPrice > 3500 && !isAccessory ? formatPrice(finalPriceWithoutDownPayment - 555) : formatPrice(finalPriceWithoutDownPayment)}
									</Typography>
									{(onSale || customInstanceDiscount) &&
									<Typography variant={textVariant}
										semanticTag="span"
										className="ms-1 text-decoration-line-through">
										{formatPrice(initialPrice)}
									</Typography>}
									<Typography variant={textVariant}
										semanticTag="span"
										className="ms-1">
									(UVP)
									</Typography>
									<Typography variant={textVariant}
										semanticTag="div">
									Inklusive MwSt.
									</Typography>
								</div>)
							}
						</div>
					</div>
				</div>
			</div>

			{hasEditFinancingBtn &&
				<Typography
					variant="bodyXSmBold"
					semanticTag="p"
					className="mb-0 new-mbp-link cursor-pointer"
					onClick={handleEditFinanceBtnClick}> {t("edit-plan")}
				</Typography>
			}
		</div>

	)
}

export default PriceTooltipWithCheckoutBtn
